<template>
  <div class="park">
    <div class="current">当前位置：园区简介</div>
    <div class="content">
      <div class="content-title">河南科慧产业园简介</div>
      <div class="oneP">
        河南科慧产业园管理有限公司成立于2022年5月，项目投资1亿元，是河南日报社(集团公司)旗下河南大河速递有限公司与济源市王屋镇政府共同创办的数字产业园。是围绕道路货运/网络货运、再生资源、通讯信息为一体的大数据产业园，主要通过合作奖励、金融赋能、品誉提升、教育赋能、技术赋能等，为入园企业提供高质量、一站式全链条服务。
      </div>
      <div class="twoP">
        科慧产业园是以园区服务为主体的综合方案解决提供商。让入园企业以科慧提供的方案为导向，获得更好的生存与发展。
      </div>
      <div class="threeP">
        2022年9月，被省工信厅认定为全省9家大数据产业示范园培育园之一，10月，获批成为河南首批数字资产评估试点企业。2023年8月，被省工信厅评为“2023年河南省大数据产业优秀标杆，11月，获评2023年河南省大数据产业示范园区。园区自筹建以来，服务省内二十多家行业领军企业入驻。截止2023年12月，科慧大数据校验平台交易额达16亿。
      </div>
      <div class="fourP">
        科慧面向省内外各相关行业企业，提供数据管理产品和服务，通过整合平台数据，发掘数据价值，实现数据资源化、资产化、资本化，聚力打造百亿级数字经济产业集群新高地。
      </div>
      <div class="img">
        <img
          src="../assets/other/pank.jpg"
          style="height: 384px; width: 100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.park {
  width: 1200px;
  margin: 0 auto;
  .current {
    padding: 30px 0;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9e9e9e;
    border-bottom: 1px dashed #cccccc;
  }
  .content {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 48px;

    .content-title {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #010101;
      padding: 57px 0 48px 0;
      text-align: center;
    }
    .oneP {
      text-indent: 40px;
    }
    .twoP {
      text-indent: 40px;
    }
    .threeP {
      text-indent: 40px;
    }
    .fourP {
      text-indent: 40px;
    }
    .img {
      margin-top: 14px;
      margin-bottom: 55px;
    }
  }
}
</style>